import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeftRight,
  PlusCircle,
  ThreeDotsVertical,
} from "react-bootstrap-icons";
import { Column } from "../../../../Components/Tables/Table";
import { formatDate, prepareSearchColumns } from "../../../../Utility/Utility";
import { useGlobalFilter } from "../../../../hooks/useGlobalFilter";
import { SubmitHandler, useForm } from "react-hook-form";
import { useSearchStore } from "../../../../store/search/searchStore";
import Loader from "../../../../Components/GlobalLoader/Loader";
import useWarehouseStore from "../../../../store/warehouse/useWarehouseStore";
import useClientStore from "../../../../store/client/useClientStore";
import PickPlanList from "../List/PickPlanList";
import { deletePickPlanById } from "../service/pickplan.service";
import toast, { Toaster } from "react-hot-toast";
import CommonConfirmationModal from "../../../../Components/Modals/CommonConfirmationModal";
import { ApiResponse } from "../../../../model/common/apiResponse";
interface OutboundPickPlanProps {
  pageName: string;
  headerName: string;
}

const defaultProps: OutboundPickPlanProps = {
  pageName: "Pick Plan",
  headerName: "Pick Plans",
};
export default function PickPlanOverview(props: OutboundPickPlanProps) {
  const navigation = useNavigate();
  const { resetSearch } = useSearchStore();
  const [loading, setLoading] = useState(true);
  const [warehouseId, setWarehouseId] = useState<any>(null);
  const [clientId, setClientId] = useState<any>(null);
  const addUrl = "/outbound/pick-plans/add";
  const listUrl = "/outbound/pick-plans";
  const [advancedFilterData, setAdvancedFilterData] = useState<any>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const buttonStatus = true;
  const [confirmModalData, setConfirmModalData] = useState({
    id: 0,
    showconfModal: false,
    message: "",
  });
  const { pageName, headerName} = props;

  const advanceFilterMapper: any = {};

  const { isShowCanvas, toggleFilter, handleFilterCount, activeFilterCount } =
    useGlobalFilter();

  const {
    handleSubmit,
    register,
    reset,
    control,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {},
  });

  const db_columns = [
    {
      data: "pick_plan_config.id",
    },
    {
      data: "pick_plan_config.description",
    },
    {
      data: "pick_plan_config.priority",
    },
    {
      data: "pick_plan_config.created_at",
    },
    {
      data: "pick_plan_config.pick_method",
    },
  ];

  const { getSelectedWarehouse } = useWarehouseStore();
  const { getSelectedClient } = useClientStore();

  useEffect(() => {
    const subscriptionWarehouse = getSelectedWarehouse().subscribe(
      (warehouse) => {
        setWarehouseId(warehouse?.id);
      }
    );
    const subscriptionClient = getSelectedClient().subscribe((client) => {
      setClientId(client?.id);
    });

    return () => {
      subscriptionWarehouse.unsubscribe();
      subscriptionClient.unsubscribe();
    };
  }, [getSelectedWarehouse, getSelectedClient]);

  const handleEditAction = (id: any) => {
    return navigation(`/outbound/pick-plans/edit/${id}`);
  };
  const handleDetailAction = (id: any) => {
    return navigation(`/outbound/pick-plans/details/${id}`);
  };
  const handleDeleteAction = (row: any) => {
    setConfirmModalData({
      id: row.id,
      showconfModal: true,
      message: `Are you sure you want to delete this Pick Plan Id ${row.id}?`,
    });
  };

  const handleconfClose = () => {
    setConfirmModalData({
      id: 0,
      showconfModal: false,
      message: "",
    });
  };

  const onDeleteModalSubmit = async (isAccept: boolean) => {
    if (confirmModalData.id !== 0 && isAccept) {
      deletePickPlanById(confirmModalData.id.toString()).then(
        (response: ApiResponse<any>) => {
          if (response.status == 200) {
            toast.success("Pick Plan deleted successfully!");
            setRefreshTrigger((prev) => prev + 1);
          } else {
            toast.error("Failed to delete the Pick Plan!");
          }
        }
      );
    }

    handleconfClose();
  };

  const handleRowClick = (id: any) => {
    return navigation(`/outbound/pick-plans/details/${id}`);
  };

  const exclude_columns = [
    "no_of_lines",
    "total_qty_expected",
    "total_qty_received",
  ];
  const search_columns = prepareSearchColumns(db_columns, exclude_columns);

  const columns: Column[] = [
    {
      name: "Pick Plan ID",
      column_name: "pick_plan_config.id",
      enableSorting: true,
      selector: (row: any) => (
        <span
          className="cursor-pointer text-primary"
          onClick={() => handleRowClick(row?.id)}
        >
          {row?.id ?? "?"}
        </span>
      ),
    },
    {
      name: "Description",
      column_name: "pick_plan_config.description",
      selector: (row: any) => (
        <span title={row?.description?.length > 15 ? row.description : ""}>
          {row?.description?.length > 15
            ? `${row.description.slice(0, 15)}...`
            : row?.description ?? "-"}
        </span>
      ),
    },
    {
      name: "Priority",
      column_name: "pick_plan_config.priority",
      selector: (row: any) => row?.priority ?? "-",
    },
    {
      name: "Pick Type",
      column_name: "pick_plan_config.pick_type",
      selector: (row: any) => row?.pick_method ?? "_",
    },
    {
      name: "Created On",
      column_name: "pick_plan_config.created_at",
      selector: (row: any) => formatDate(row?.created_at) ?? "-",
    },
    {
      name: (
        <>
          <ArrowLeftRight
            className="me-2"
            style={{ stroke: "black", strokeWidth: 1 }}
          />
          <PlusCircle style={{ stroke: "black", strokeWidth: 1 }} />
        </>
      ),
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items px-0 py-1">
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handleDetailAction(row?.id)}
            >
              View
            </li>
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handleEditAction(row?.id)}
            >
              Edit
            </li>
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handleDeleteAction(row)}
            >
              Delete
            </li>
          </ul>
        </>
      ),
    },
  ];

  useEffect(() => {
    resetSearch();
    setLoading(false);
  }, []);

  const handleGlobalFilter = () => {
    toggleFilter();
  };

  const nextData: SubmitHandler<any> = (data) => {
    setRefreshTrigger(refreshTrigger + 1);
    handleFilterCount(data);
    setAdvancedFilterData(data);
    toggleFilter();
  };

  const handelResetFilter = () => {
    reset({});
    handleFilterCount(0);
    toggleFilter();
    setAdvancedFilterData(null);
  };

  return !loading ? (
    <>
      <Toaster />
      <PickPlanList
        db_columns={db_columns}
        search_columns={search_columns}
        columns={columns}
        pageName={pageName}
        headerName={headerName}
        addUrl={addUrl}
        listUrl={listUrl}
        handleGlobalFilter={handleGlobalFilter}
        buttonStatus={buttonStatus}
        checkboxStatus={false}
        tableMultiSelect={null}
        refreshTrigger={refreshTrigger}
        advancedFilterData={advancedFilterData}
        filterDataCount={activeFilterCount}
        advanceFilterMapper={advanceFilterMapper}
        warehouseId={warehouseId}
        clientId={clientId}
      />
      <CommonConfirmationModal
        customClassName="header-border"
        show={confirmModalData.showconfModal}
        content={<>{confirmModalData.message}</>}
        onModalSubmit={onDeleteModalSubmit}
      />
    </>
  ) : (
    <Loader />
  );
}
PickPlanOverview.defaultProps = defaultProps;